module.exports = __webpack_public_path__ + "img/shopping-bag.dd75d800.svg";